import styled from "styled-components";

export const TabsContainer = styled.div`
  width: 100%;
  padding: 0 20px;
`;

